const CustomIdentifyUtils = {
    parseGml(response, layer) {
        const layerName = layer.name;
        const parser = new DOMParser();

        const doc = parser.parseFromString(response, "text/xml");
        const featureMembers = [].slice.call(doc.getElementsByTagName("gml:featureMember"));
        const features = [];

        for (const featureMember of featureMembers) {
            for (const featureMemberObject of [].slice.call(featureMember.children)) {
                const feature = {
                    id: featureMemberObject.getAttribute('fid'),
                    type: 'feature',
                    properties: {}
                };
                for (const child of [].slice.call(featureMemberObject.children)) {
                    if (child.firstChild) {
                        feature.properties[child.localName] = child.firstChild.nodeValue || null;
                    }
                }
                features.push(feature);
            }
        }
        const results = {};
        results[layerName] = features;
        return results;
    }
};

export default CustomIdentifyUtils;
